var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRedCross(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "red-cross",
    width: "11px",
    height: "11px",
    viewBox: "0 0 11 11",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "red-cross-1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "red-cross-1",
    points: "8.83938815 0 11 2.19992213 7.66080306 5.59987257 10.8038241 8.80007787 8.64282983 11 5.5001912 7.80018406 2.35717017 11 0.196558317 8.80007787 3.33957935 5.59987257 0 2.19992213 2.16061185 0 5.5001912 3.39995044"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "red-cross-2",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "red-cross-3",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    id: "red-cross-4",
    xlinkHref: "#red-cross-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "red-cross-5",
    fill: "#FF1B17",
    xlinkHref: "#red-cross-1"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedCross);
export default __webpack_public_path__ + "static/media/red-cross.843039f04675e2eb2951606f0509c748.svg";
export { ForwardRef as ReactComponent };